import { FieldInstruction, FormValues } from 'containers/FormBuilder'
import InputField from 'form/fieldComponents/InputField'
import TextAreaField from 'form/fieldComponents/TextAreaField'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

function requiredValidation(): (formValues: FormValues) => Yup.StringSchema {
    return (formValues) => {
        return Yup.string().required(FIELD_REQUIRED)
    }
}

export function createStockNumberWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Stock Number',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInDescriptionWithValidation(): FieldInstruction<
    typeof TextAreaField
> {
    return {
        Component: TextAreaField,
        config: {
            label: 'Trade-in description',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInColorWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Color',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInYearWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Year',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInMakeWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Make',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInModelWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Model',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInVinWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Trade-in VIN',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInBodyWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Body Style',
            validator: requiredValidation(),
        },
    }
}

export function createTradeInLienHolder(): FieldInstruction<typeof InputField> {
    return {
        Component: InputField,
        config: {
            label: 'Lien Holder Name',
        },
    }
}
